<div class="app-picker">
  <div class="app-picker-card">
    <!-- Heading stays hidden until we know there is actually a choice to make,
         so a single-app user is never told they have more than one. -->
    <ng-container *ngIf="!loading && !error && apps.length > 1">
      <h1>Choose an application</h1>
      <p class="subtitle">You have access to more than one application. Select which one to open.</p>
    </ng-container>

    <div class="app-picker-loading" *ngIf="loading">
      <mat-icon>hourglass_empty</mat-icon>
      <span>Loading your applications…</span>
    </div>

    <div class="app-picker-error" *ngIf="error && !loading">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>

    <ul class="app-list" *ngIf="!loading && !error">
      <li *ngFor="let app of apps">
        <button mat-raised-button color="primary" class="app-item" (click)="select(app)">
          <mat-icon>business</mat-icon>
          <span class="app-name">{{ displayName(app) }}</span>
        </button>
      </li>
    </ul>
  </div>
</div>
